import { supabase } from "@/integrations/supabase/client";

export type Inquiry = {
  name: string;
  email: string;
  phone?: string | null;
  message: string;
  submittedAt?: string;
  /** Optional custom email subject (e.g. partner or vehicle submissions). */
  subject?: string;
  /** Which form sent it; shown in the /admin/submissions hub. */
  formType?: "contact" | "partner" | "consign" | "review";
};

/**
 * Shared submission handler for every enquiry form (contact, partners,
 * rent-out-your-car): saves the enquiry, then notifies info@avoluscars.com.
 */
export async function submitInquiry(input: Inquiry): Promise<{ error: unknown | null }> {
  const submittedAt = input.submittedAt ?? new Date().toISOString();
  const { error } = await supabase.from("contact_submissions").insert({
    name: input.name,
    email: input.email,
    phone: input.phone || null,
    message: input.message,
    form_type: input.formType ?? "contact",
    subject: input.subject ?? null,
  });
  if (error) return { error };

  // Fire-and-forget email notification to the concierge inbox.
  fetch("/api/public/contact-notify", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      name: input.name,
      email: input.email,
      phone: input.phone || null,
      message: input.message,
      submittedAt,
      ...(input.subject ? { subject: input.subject } : {}),
    }),
  }).catch(() => {
    // Submission already saved; silent on email failure.
  });

  return { error: null };
}
